import { Action } from 'redux';
import { push } from 'connected-react-router';
import { smartRequestsRoute } from '../../../../../routes/toolbox/smartRequestsPanel/smartRequestsRoute';

export const goToSmartRequests = (projectId: string): Action =>
  push(smartRequestsRoute.makePath({ projectId }));
